import {
    STATEMENTS_GET_AGGREGATE_RANGE_REQUEST,
    STATEMENTS_GET_AGGREGATE_RANGE_SUCCESS,
    STATEMENTS_GET_AGGREGATE_RANGE_FAILURE,
    STATEMENTS_SET_DATERANGE_FILTERS_SUCCESS,
    STATEMENTS_GET_PRODUCT_NAMES_REQUEST,
    STATEMENTS_GET_PRODUCT_NAMES_SUCCESS,
    STATEMENTS_GET_PRODUCT_NAMES_FAILURE,
    STATEMENTS_GET_REPRESENTATIVES_REQUEST,
    STATEMENTS_GET_REPRESENTATIVES_SUCCESS,
    STATEMENTS_GET_REPRESENTATIVES_FAILURE
  } from './actions';
  
  import _ from 'lodash';
  
  import createReducer from 'state/createReducer';
  
  const initialState = {
    aggregateRange: {
      request: false,
      data: []
    }
  };
  
  const handlers = {
    [STATEMENTS_GET_AGGREGATE_RANGE_REQUEST](state) {
      return {
        ...state,
        aggregateRange: {
          ...state.aggregateRange,
          request: true
        }
      };
    },
  
    [STATEMENTS_GET_AGGREGATE_RANGE_SUCCESS](state, payload) {
      return {
        ...state,
        aggregateRange: {
          request: false,
          data: payload
        }
      };
    },
  
    [STATEMENTS_GET_AGGREGATE_RANGE_FAILURE](state, payload) {
      return {
        ...state,
        aggregateRange: {
          ...state.aggregateRange,
          request: false
        }
      };
    },
  
    [STATEMENTS_SET_DATERANGE_FILTERS_SUCCESS](state, payload) {
      const newActiveFilters = { ...state.activeFilters };
      newActiveFilters['daterange'] = {
        startDate: payload.startDate,
        endDate: payload.endDate,
      }
      newActiveFilters['vendorID'] = {
        vendorID: payload.vID
      }
  
      return {
        ...state,
        activeFilters: newActiveFilters
      }
    },

    [STATEMENTS_GET_PRODUCT_NAMES_REQUEST](state) {
      return {
        ...state,
        prodNamesRequest: true,
        prodNames: []
      };
    },

    [STATEMENTS_GET_PRODUCT_NAMES_SUCCESS](state, payload) {
      return {
        ...state,
        prodNamesRequest: false,
        prodNames: payload
      };
    },

    [STATEMENTS_GET_PRODUCT_NAMES_FAILURE](state) {
      return {
        ...state,
        prodNamesRequest: false,
        prodNames: []
      };
    },
    [STATEMENTS_GET_REPRESENTATIVES_REQUEST](state) {
      return {
        ...state,
        representativesRequest: true,
        representatives: []
      };
    },
    [STATEMENTS_GET_REPRESENTATIVES_SUCCESS](state, payload) {
      return {
        ...state,
        representativesRequest: false,
        representatives: payload
      };
    },
    [STATEMENTS_GET_REPRESENTATIVES_FAILURE](state) {
      return {
        ...state,
        representativesRequest: false,
        representatives: []
      };
    }
    
  };
  
  export default (state = initialState, action) => createReducer(state, action, handlers);